import {findParent} from '../../js/tools';

const Selector = {
  ITEM: '.jk-accordion__item',
  HEADER: '.jk-accordion__item-header',
  BODY: '.jk-accordion__item-body',
  BODY_WRAPPER: '.jk-accordion__item-body-wrapper',
};

export class Accordion {
  elements = {
    root: null,
  };

  constructor(element) {
    if (!element) {
      return;
    }

    this.elements = {
      root: element,
      items: element.querySelectorAll(Selector.ITEM),
      bodies: element.querySelectorAll(Selector.BODY),
      getItemElements(item) {
        return {
          body: item.querySelector(Selector.BODY),
          bodyWrapper: item.querySelector(Selector.BODY_WRAPPER),
        };
      },
    };

    this.wrapBodies();
    this.setBodyWrapperHeights();
    this.addEventListeners();
    this.addTabIndexes();
  }

  wrapBodies() {
    for (const body of this.elements.bodies) {
      const wrapper = document.createElement('div');

      wrapper.className = Selector.BODY_WRAPPER.slice(1);
      body.parentElement.insertBefore(wrapper, body);
      wrapper.append(body);
    }
  }

  setBodyWrapperHeights() {
    // for transitions
    for (const item of this.elements.items) {
      const { body, bodyWrapper } = this.elements.getItemElements(item);
      let height = 0;

      if (item.classList.contains('open')) {
        height = body.offsetHeight;
      }

      bodyWrapper.style.height = `${height}px`;
    }
  }

  addEventListeners() {
    const handleAction = () => {
      // prevent multi-clicking from selecting text
      document.getSelection()?.removeAllRanges();

      const item = findParent(event.target, Selector.ITEM);
      item.classList.toggle('open');

      if (item.classList.contains('open')) {
        this.openItem(item);
      } else {
        this.closeItem(item);
      }
    };

    this.elements.root.addEventListener('click', (event) => {
      if (event.target.matches(Selector.HEADER)) {
        handleAction();
      }
    });
    this.elements.root.addEventListener('keydown', (event) => {
      if (event.target.matches(Selector.HEADER) && event.key === 'Enter') {
        handleAction();
      }
    });
  }

  addTabIndexes() {
    this.elements.root.querySelectorAll(Selector.HEADER).forEach(element => element.setAttribute('tabindex', 0));
  }

  openItem(item) {
    const { body, bodyWrapper } = this.elements.getItemElements(item);

    bodyWrapper.style.height = `${body.offsetHeight}px`;
  }

  closeItem(item) {
    const { bodyWrapper } = this.elements.getItemElements(item);

    bodyWrapper.style.height = 0;
  }
}
